import DateUtil from 'client/util/DateUtil';

/**
 * Calculates the number of days left in the fair use period. Negative values
 * indicate the customer is past their fair use period.
 *
 * @param {String} trialStart ISOString of trial start date
 * @returns {number} Number of days remaining in fair use period.
 */
export default function daysLeftInFairUsePeriod(trialStart) {
  const trialDays = 30;
  const start = DateUtil.startOfDay(trialStart);
  let daysElapsed = DateUtil.daysAfter(start);
  daysElapsed = Math.floor(daysElapsed);
  if (daysElapsed >= 30) {
    daysElapsed += 1;
  }

  return trialDays - daysElapsed;
}
